"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M1.997 19h13.436c.828 0 1.498-.685 1.498-1.53V6.53c0-.845-.67-1.53-1.498-1.53H1.997C1.17 5 .5 5.685.5 6.53v10.94c0 .845.67 1.53 1.497 1.53zM24.774 17.266l-5.163-2.683V9.417l5.163-2.683c.33-.172.722.076.722.455v9.622c0 .383-.39.628-.722.455z" }), "Video");
//# sourceMappingURL=Video.js.map